import { createFileRoute } from '@tanstack/react-router';

import { BehaviorPage } from '@/features/parent/BehaviorPage';

export const Route = createFileRoute('/_authed/parent/behavior')({
  component: BehaviorPage,
});
